import _default from './Placeholder';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Placeholder/index.js
// module id = 3267
// module chunks = 0